<script lang="ts">
  import MainMenu from './lib/main-menu.svelte';
  import PlayerSelect from './lib/player-select.svelte';
  import UpgradeScreen from './lib/upgrade-screen.svelte';
  import BattleStart from './lib/battle-start.svelte';
  import BattleOver from './lib/battle-over.svelte';
  import GameBoard from './lib/game-board.svelte';
  import Styles from './lib/styles.svelte';
  import Map from './lib/map.svelte';
  import Event from './lib/event-screen.svelte';
  import Audio from './lib/components/audio.svelte';
  import Glossary from './lib/glossary/glossary.svelte';
  import Farm from './lib/farm.svelte';
  import { glossary, screens } from './store';
  import { get } from 'svelte/store';
  import Modals from './lib/modals/modal.svelte';
  import TipLayer from './lib/components/tip-layer.svelte';
  import * as Sentry from '@sentry/svelte';

  import logo72 from './assets/icons/logo-72.png';
  import logo96 from './assets/icons/logo-96.png';
  import logo120 from './assets/icons/logo-120.png';
  import logo128 from './assets/icons/logo-128.png';
  import logo144 from './assets/icons/logo-144.png';
  import logo152 from './assets/icons/logo-152.png';
  import logo180 from './assets/icons/logo-180.png';
  import logo192 from './assets/icons/logo-192.png';
  import logo384 from './assets/icons/logo-384.png';
  import logo512 from './assets/icons/logo-512.png';
  import { Screen } from './lib/models/screen.type';

  // import { auditEnemies } from "./audit";
  // auditEnemies();

  if (location.hostname == 'odam.clarklavery.com') {
    Sentry.init({
      dsn: 'https://547f30c6f0bb4aa2b6109c113cec103d@o4505600564854784.ingest.us.sentry.io/4505600568262656',
      integrations: [],
      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: [/^https:\/\/odam\.clarklavery\.com/],
    });
  }

  var glossaryOpen = $state(true);
  glossary.open.subscribe((val) => {
    glossaryOpen = val;
  });

  var fullscreen = false;

  // The screens store edits its entries in place and hands back the same array.
  // In runes mode an {#each} redraws an item only when it is a new object, so
  // each one is copied -- a screen whose state changed arrives as a new object.
  // get() rather than $screens: this runs inside the store's own subscription,
  // where a lazily subscribed $screens can still hold the previous value.
  const copyScreens = () => get(screens).map((screen) => ({ ...screen }));

  let screensUI: Array<any> = $state.raw(copyScreens());
  screens.subscribe((val) => {
    // if any vals are loading, set to visible
    val.forEach((val) => {
      if (val.state == 'loading') {
        setTimeout(() => {
          if (val.state == 'loading') {
            val.state = 'visible';
          }
          screensUI = copyScreens();
        });
      }
    });
    //if there are no vals set to visible or loading, set the last hidden one to visible
    if (val.filter((val) => val.state == 'visible' || val.state == 'loading').length == 0) {
      const last = val.findLast((val) => val.state == 'hidden');
      if (last) {
        last.state = 'visible';
      }
    }
    screensUI = copyScreens();
  });

  function toggleFullscreen() {
    return;
    if (!fullscreen) {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
      /* else if (elem.webkitRequestFullscreen) { // Safari
        elem.webkitRequestFullscreen();
      }
      else if (elem.msRequestFullscreen) { // IE11
        elem.msRequestFullscreen();
      } */

      fullscreen = true;
    }
    /* else{
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

      fullscreen = false;
    } */
  }
</script>

<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<main
  class=""
  onclick={toggleFullscreen}
  onkeydown={() => {
    /* no-op */
  }}
>
  {#each screensUI as screen, index}
    <div class="full-screen {screen.state}">
      {#if screen.state !== 'unloaded'}
        {#if screen.type == Screen.Menu}
          <MainMenu />
        {/if}

        {#if screen.type == Screen.PlayerSelect}
          <PlayerSelect />
        {/if}

        {#if screen.type == Screen.Map}
          <Map data={screen.data} />
        {/if}

        {#if screen.type == Screen.Event}
          <Event data={screen.data} />
        {/if}

        {#if screen.type == Screen.Battle}
          <GameBoard data={screen.data} />
        {/if}

        {#if screen.type == Screen.Upgrade}
          <UpgradeScreen />
        {/if}

        {#if screen.type == Screen.BattleStart}
          <BattleStart data={screen.data} />
        {/if}

        {#if screen.type == Screen.BattleOver}
          <BattleOver data={screen.data} />
        {/if}

        {#if screen.type == Screen.Styles}
          <Styles />
        {/if}

        {#if screen.type == Screen.Farm}
          <Farm />
        {/if}
      {/if}
    </div>
  {/each}

  <div class="full-screen no-background {glossaryOpen ? 'visible' : ''}" style="z-index:111;">
    <Glossary />
  </div>
</main>

<Modals></Modals>
<!-- The tip for every keyword in game text; see components/tip-layer.svelte. -->
<TipLayer />

<Audio></Audio>

<svelte:head>
  <link rel="icon" type="image/png" href={logo512} />
  <meta charset="utf-8" />
  <meta http-equiv="x-ua-compatible" content="IE=edge" />
  <meta name="description" content="Dice Game." />
  <meta name="keywords" content="Game Dice RPG" />
  <meta
    name="viewport"
    content="viewport-fit=cover, width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, minimal-ui"
  />

  <!-- Android  -->
  <meta name="theme-color" content="#4d4365" />
  <meta name="mobile-web-app-capable" content="yes" />

  <!-- iOS -->
  <meta name="apple-mobile-web-app-title" content="Odam" />
  <!-- <meta name="apple-mobile-web-app-capable" content="yes"> -->
  <meta name="apple-mobile-web-app-status-bar-style" content="default" />

  <!-- Windows  -->
  <meta name="msapplication-navbutton-color" content="#4d4365" />
  <meta name="msapplication-TileColor" content="#4d4365" />
  <meta name="msapplication-TileImage" content={logo144} />
  <meta name="msapplication-config" content="browserconfig.xml" />

  <!-- Pinned Sites  -->
  <meta name="application-name" content="Odam" />
  <meta name="msapplication-tooltip" content="Dice Game." />
  <meta name="msapplication-starturl" content="./" />

  <!-- Tap highlighting  -->
  <meta name="msapplication-tap-highlight" content="no" />

  <!-- UC Mobile Browser  -->
  <meta name="full-screen" content="yes" />
  <meta name="browsermode" content="application" />

  <!-- Disable night mode for this page  -->
  <meta name="nightmode" content="enable" />

  <!-- Layout mode -->
  <meta name="layoutmode" content="fitscreen/standard" />

  <!-- Main Link Tags  -->
  <link rel="icon" type="image/png" href={logo72} sizes="72x72" />

  <!-- iOS  -->
  <link href={logo120} rel="apple-touch-icon" />
  <link href={logo120} rel="apple-touch-icon" sizes="120x120" />
  <link href="(logo180)" rel="apple-touch-icon" sizes="180x180" />

  <!-- Startup Image  -->
  <link href={logo512} rel="apple-touch-startup-image" />

  <!-- Pinned Tab  -->
  <!-- <link href={logo512} rel="mask-icon" size="any" color="#455357"> -->

  <!-- Android  -->
  <link href={logo192} rel="icon" sizes="192x192" />
  <link href={logo128} rel="icon" sizes="128x128" />

  <!-- UC Browser  -->
  <link href={logo72} rel="apple-touch-icon" sizes="72x72" />
</svelte:head>

<style lang="less">
  @import './defines.less';

  :global(body) {
    overflow: hidden;
    overscroll-behavior: none;

    --light-font: #dddddd;
    --dark-font: #222831;

    --green: @green;
    --cyan: @cyan;
    --light-blue: @light-blue;
    --dark-blue: @dark-blue;
    --purple: @purple;
    --pink: @pink;
    --red: @red;
    --orange: @orange;
    --yellow: @yellow;
    --gray: @gray;
    --brown: @brown;
    --black: @black;

    --column-size: 300px; //300
    --dice-size: 80px; //80
    --dice-gap: 10px; //15
    --dice-gap-half: 5px; //15
    --health-bar-width: 40px; //15
  }

  @media @large {
    :global(body) {
      --column-size: 240px; //300
      --dice-size: 70px; //80
      --dice-gap: 8px; //15
      --dice-gap-half: 3px; //15
      --health-bar-width: 30px; //15
      font-size: 14px;
    }
  }
  @media @medium {
    :global(body) {
      --column-size: 200px; //300
      --dice-size: 60px; //80
      --dice-gap: 8px; //15
      --dice-gap-half: 3px; //15
      --health-bar-width: 30px; //15
      font-size: 14px;
    }
  }
  @media @small {
    :global(body) {
      --column-size: 150px; //300
      --dice-size: 50px; //80
      --dice-gap: 8px; //15
      --dice-gap-half: 3px; //15
      --health-bar-width: 26px; //15
      font-size: 12px;
    }
  }

  main {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    color: var(--light-font);
    background-color: #121212;
  }
  .full-screen {
    background: var(--background-colour);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    opacity: 0;
    transition: opacity 0.5s;
    pointer-events: none;

    &.visible {
      opacity: 1;
      pointer-events: all;
    }

    &.unloaded {
      opacity: 0;
      pointer-events: none;
      transition: none;
    }

    &.no-background {
      background: none;
    }
  }
</style>
